const Reducer = (state, action) => {
  switch (action.type) {
    case "set_profile":
      return {
        ...state,
        profile: action.profile,
      };
    default:
      return state;
  }
};

export default Reducer;
